type OscillatorWave = OscillatorType

const playToneLayer = (
  ctx: AudioContext,
  start: number,
  frequency: number,
  gainValue: number,
  duration: number,
  type: OscillatorWave = 'sine',
  endFrequency?: number
) => {
  const osc = ctx.createOscillator()
  const gain = ctx.createGain()
  const filter = ctx.createBiquadFilter()

  osc.type = type
  osc.frequency.setValueAtTime(frequency, start)
  if (endFrequency) {
    osc.frequency.exponentialRampToValueAtTime(endFrequency, start + duration)
  }

  filter.type = 'lowpass'
  filter.frequency.setValueAtTime(1800, start)

  gain.gain.setValueAtTime(0.0001, start)
  gain.gain.exponentialRampToValueAtTime(gainValue, start + 0.018)
  gain.gain.exponentialRampToValueAtTime(0.0001, start + duration)

  osc.connect(filter)
  filter.connect(gain)
  gain.connect(ctx.destination)
  osc.start(start)
  osc.stop(start + duration + 0.02)
}

export const playSupportAlertTone = (ctx: AudioContext) => {
  const now = ctx.currentTime
  playToneLayer(ctx, now, 392, 0.16, 0.18, 'triangle', 294)
  playToneLayer(ctx, now + 0.12, 659, 0.11, 0.24, 'sine', 523)
  playToneLayer(ctx, now + 0.26, 988, 0.055, 0.16, 'sine', 784)
}
